import React from 'react'
// import 'bootstrap/dist/css/bootstrap.min.css';
import '../Styles/Skills.css';

const Skills = () => {
    return (
        <section className="skills_section" id='Skills'>
            <div className="skills_head ">
                <h1>SKILLS</h1>
                <h2 className='flex'>My <span>Skills</span></h2>
                <p>Here is my skills to represent my Expertise</p>
            </div>
            <div className="TitlesSkills flex ">
                <h2>Frontend Skills</h2>
                <h2>Backend Skills</h2>
            </div>
            <div style={{ justifyContent: "space-between" }} className='All-skills flex ' >

                <div className="skills_main ">
                    <div className="skill_bar">
                        <div className="info">
                            <p>HTML</p>
                            <p>98%</p>
                        </div>
                        <div className="bar">
                            <span className="html"></span>
                        </div>
                    </div>
                    <div className="skill_bar">
                        <div className="info">
                            <p>CSS</p>
                            <p>90%</p>
                        </div>
                        <div className="bar">
                            <span className="css"></span>
                        </div>
                    </div>
                    <div className="skill_bar">
                        <div className="info">
                            <p>Java Script</p>
                            <p>80%</p>
                        </div>
                        <div className="bar">
                            <span className="js"></span>
                        </div>
                    </div>
                    <div className="skill_bar">
                        <div className="info">
                            <p>React js</p>
                            <p>75%</p>
                        </div>
                        <div className="bar">
                            <span className="react"></span>
                        </div>
                    </div>

                </div>

                <div className='bloc'  style={{display: 'inline-block'}}>
                    <h2>Backend Skills</h2>
                    <div className='wrapper '>
                        <div className="progress Laravel">
                            <svg className="progress-bar" width="100" height="100">
                                <circle className="progress-circle" cx="50" cy="50" r="35"></circle>
                                <circle className="progress-circle" cx="50" cy="50" r="35"></circle>
                            </svg>
                            <div className="text ">
                                80%
                                <span>Laravel</span>
                            </div>
                        </div>
                        <div className="progress Express">
                            <svg className="progress-bar" width="100" height="100">
                                <circle className="progress-circle" cx="50" cy="50" r="35"></circle>
                                <circle className="progress-circle Express" cx="50" cy="50" r="35"></circle>
                            </svg>
                            <div className="text ">
                                55%
                                <span>Express    JS</span>
                            </div>
                        </div>
                        <div className="progress Node">
                            <svg className="progress-bar" width="100" height="100">
                                <circle className="progress-circle" cx="50" cy="50" r="35"></circle>
                                <circle className="progress-circle Node" cx="50" cy="50" r="35"></circle>
                            </svg>
                            <div className="text">
                                55%
                                <span>Node Js</span>
                            </div>
                        </div>
                        <div className="progress Mongo">
                            <svg className="progress-bar" width="100" height="100">
                                <circle className="progress-circle" cx="50" cy="50" r="35"></circle>
                                <circle className="progress-circle Mongo" cx="50" cy="50" r="35"></circle>
                            </svg>
                            <div className="text ">
                                65%
                                <span>Mongo DB</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default Skills
